import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface TimelineItem {
  key: string;
  date: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  details?: ReactNode;
}

interface TimelineProps {
  items: TimelineItem[];
  className?: string;
  dateColumnClassName?: string;
}

export const Timeline = ({
  items,
  className,
  dateColumnClassName = "grid-cols-[96px_1fr]",
}: TimelineProps) => (
  <ol className={cn("flex flex-col", className)}>
    {items.map((item, index) => (
      <li key={item.key} className="flex gap-3">
        <div className="relative flex w-4 shrink-0 justify-center">
          {index !== items.length - 1 && (
            <span className="absolute top-4 bottom-0 w-px bg-border" />
          )}
          <span className="relative top-4 size-2.5 shrink-0 rounded-full bg-primary" />
        </div>
        <div
          className={cn(
            "grid flex-1 gap-4 py-3",
            dateColumnClassName,
            index !== items.length - 1 && "border-border border-b"
          )}
        >
          <div className="text-muted-foreground text-sm">{item.date}</div>
          <div className="flex min-w-0 flex-col gap-1">
            <div className="font-semibold text-foreground text-sm">{item.title}</div>
            {item.meta && <div className="text-muted-foreground text-xs">{item.meta}</div>}
            {item.details && <div className="text-muted-foreground text-sm">{item.details}</div>}
          </div>
        </div>
      </li>
    ))}
  </ol>
);
